export default __webpack_public_path__ + "static/media/xml.9fef0eb2.svg";